<template>
    <div class="content md">
        <system-admin type="space"></system-admin>
    </div>
</template>

<script>
    import SystemAdmin from "../../layouts/SystemAdmin";
    export default {
        name: "SpaceAuth",
        components: {
            SystemAdmin
        }
    }
</script>

<style scoped>

</style>